/**
 * Демонстрационный список отчётов.
 *
 * Четыре проекта и восемь отчётов: достаточно, чтобы в режиме «по проектам»
 * были и группа из трёх строк, и группа из одной, а в сплошном списке
 * встречались готовый, собирающийся и сорвавшийся отчёты подряд.
 *
 * Порядок — свежие сверху, как его задаёт вызывающий код. Проект «Ольха»
 * тот же, что в хранилище и в самом отчёте: один демонстрационный кабинет
 * на весь маршрут.
 *
 * @format
 */

import type {ReportsOverviewData} from './types';

export const MOCK_OVERVIEW: ReportsOverviewData = {
  reports: [
    {
      id: 'olha-2026-06',
      companyId: 'olha',
      companyName: 'Мебельная фабрика «Ольха»',
      periodFrom: '2026-06-01',
      periodTo: '2026-06-30',
      status: 'ready',
      generatedAt: '2026-07-01T09:14:00',
      score: 34,
      scoreZone: 'URGENT',
      unread: true,
    },
    {
      id: 'gruzovichok-2026-06',
      companyId: 'gruzovichok',
      companyName: 'Грузовичок 24',
      periodFrom: '2026-06-01',
      periodTo: '2026-06-30',
      status: 'ready',
      generatedAt: '2026-07-01T09:12:00',
      score: 71,
      scoreZone: 'NORMAL',
    },
    {
      id: 'dentalux-2026-06',
      companyId: 'dentalux',
      companyName: 'Стоматология «Денталюкс»',
      periodFrom: '2026-06-01',
      periodTo: '2026-06-30',
      status: 'building',
      note: 'Собираем данные: система разбирает историю изменений за месяц.',
    },
    {
      id: 'olha-2026-05',
      companyId: 'olha',
      companyName: 'Мебельная фабрика «Ольха»',
      periodFrom: '2026-05-01',
      periodTo: '2026-05-31',
      status: 'ready',
      generatedAt: '2026-06-01T09:07:00',
      score: 55,
      scoreZone: 'NEEDS_ATTENTION',
    },
    {
      id: 'gruzovichok-2026-05',
      companyId: 'gruzovichok',
      companyName: 'Грузовичок 24',
      periodFrom: '2026-05-01',
      periodTo: '2026-05-31',
      status: 'ready',
      generatedAt: '2026-06-01T09:05:00',
      score: 68,
      scoreZone: 'NORMAL',
    },
    {
      id: 'severnyi-2026-05',
      companyId: 'severnyi',
      companyName: 'ЖК «Северный»',
      periodFrom: '2026-05-01',
      periodTo: '2026-05-31',
      status: 'failed',
      note: 'У проекта нет медиаплана',
    },
    {
      id: 'olha-2026-04',
      companyId: 'olha',
      companyName: 'Мебельная фабрика «Ольха»',
      periodFrom: '2026-04-01',
      periodTo: '2026-04-30',
      status: 'ready',
      generatedAt: '2026-05-01T09:03:00',
      score: 39,
      scoreZone: 'URGENT',
    },
    {
      id: 'dentalux-2026-04',
      companyId: 'dentalux',
      companyName: 'Стоматология «Денталюкс»',
      periodFrom: '2026-04-01',
      periodTo: '2026-04-30',
      status: 'ready',
      generatedAt: '2026-05-01T09:01:00',
      score: 88,
      scoreZone: 'EXCELLENT',
    },
  ],
};

/** Ничего не собрано: кабинеты подключены, первый период ещё не закрыт. */
export const MOCK_OVERVIEW_EMPTY: ReportsOverviewData = {reports: []};

/** Один проект: список, у которого группировка ничего не меняет. */
export const MOCK_OVERVIEW_SINGLE: ReportsOverviewData = {
  reports: MOCK_OVERVIEW.reports.filter(report => report.companyId === 'olha'),
};
